import React from 'react';
import { Anohana, Btn, Bx, IconBtn, Typo } from '@curry-group/mui-curcuma';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faImages, faClock } from '@fortawesome/pro-light-svg-icons';

/**
 * Reminder shown after login to users without a profile picture.
 * "Profilbild hochladen" links to the own profile. Only the "Später erinnern"
 * button snoozes the reminder for half a year; the close icon and an outside
 * click just dismiss it without snoozing, so it can reappear on the next login.
 */
export const ProfilePictureReminderDialog: React.FC<{
  open: boolean;
  onUpload: () => void;
  onRemindLater: () => void;
  onDismiss: () => void;
}> = ({ open, onUpload, onRemindLater, onDismiss }) => {
  return (
    <Anohana open={!!open} transition="zoom" disableScrollLock fullWidth maxWidth="sm" onClose={onDismiss}>
      <Bx p={2.5}>
        <Bx display="flex" alignItems="flex-start" mb={3}>
          <Typo variant="h4" component="span">
            👋 Hallo! Dein Profil ist fast vollständig.
          </Typo>
          <Bx ml="auto" mr={-1}>
            <IconBtn onClick={onDismiss} title="Schließen">
              <FontAwesomeIcon icon={faTimes} />
            </IconBtn>
          </Bx>
        </Bx>

        <Bx mb={3}>
          <Typo variant="subtitle1" component="p">
            Füge jetzt ein Profilbild hinzu – so wirst du von anderen schneller erkannt und hinterlässt einen persönlicheren Eindruck.
          </Typo>
        </Bx>

        <Bx display="flex" flexWrap="wrap" mt={3} justifyContent="flex-end">
          <Bx mr={3}>
            <Btn
              variant="outlined"
              size="large"
              startIcon={<FontAwesomeIcon icon={faClock} />}
              onClick={onRemindLater}
            >
              Später erinnern
            </Btn>
          </Bx>
          <Bx>
            <Btn
              variant="contained"
              color="success"
              size="large"
              startIcon={<FontAwesomeIcon icon={faImages} />}
              onClick={onUpload}
            >
              Profilbild hochladen
            </Btn>
          </Bx>
        </Bx>
      </Bx>
    </Anohana>
  );
};
